<template>
    <div class="container py-5">
        <h1>Produtos</h1>
        <p>Conteúdo da página de Produtos</p>
    </div>
</template>

<script>
export default {
    name: 'ProdutosPage'
};
</script>